<template>
  <vs-prompt
    :title="titleText"
    @accept="acceptClicked"
    :active.sync="popupOpen"
    :accept-text="actionText"
    :is-valid="validForm"
  >
    <div v-if="schema">
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Is active</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-switch color="success" v-model="schema.active" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Title</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-input
            class="inputx w-full"
            label="Title"
            placeholder="Title"
            v-model="schema.title"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>PowerBI details</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input
            class="inputx w-full"
            label="Workspace ID"
            placeholder="Workspace ID"
            v-model="schema.workspaceId"
          />
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input
            class="inputx w-full"
            label="Report ID"
            placeholder="Report ID"
            v-model="schema.reportId"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Description</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-textarea
            placeholder="Description of report"
            class="w-full"
            height="68px"
            v-model="schema.description"
          />
        </div>
      </div>

         <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>PowerBI Venue Filter</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
         <span>Enable this to filter by venues that user has access to</span><vs-switch color="success" v-model="schema.venueFilter" />
        </div>
      </div>


      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>IDAM permission</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-input
            class="inputx w-full"
            label="Leave empty if anybody with Cockpit access can view"
            placeholder="Permission ID"
            v-model="schema.permission"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Category</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-select label="Category" v-model="schema.category">
            <vs-select-item
              :key="category.index"
              :value="category.index"
              :text="category.name"
              v-for="category in categories"
            />
          </vs-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Order in category</span>
        </div>
        <div class="vx-col sm:w-1/5 w-full">
          <vs-input-number min="0" v-model="schema.index" />
        </div>
      </div>

      <div class="buttons-footer-left">
        <vs-button
          v-if="!isNew"
          color="danger"
          @click.native="confirmDelete"
          type="border"
          class="ml-2"
          >Delete</vs-button
        >
      </div>
    </div>
  </vs-prompt>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {
      popupOpen: false,
      schemaOrg: {
        id: null,
        active: true,
        venueFilter: true,
        category: 0,
        description: "",
        index: 0,
        link: "",
        permission: "",
        reportId: "",
        workspaceId: "1cc80cf3-73e3-4928-a349-dc2ffc56e634",
        title: "",
        viewtype: 0,
      },
      schema: { id: null },
    };
  },
  computed: {
    ...mapGetters({
      categories: "cockpitReports/categories",
      categoryMap: "cockpitReports/categoryMap",
      activeVenue: "venues/activeVenue",
      userId: "users/userId",
    }),
    titleText() {
      return this.actionText + " " + this.objectName;
    },
    objectName() {
      return "report";
    },
    isNew() {
      return this.schema.id === null;
    },
    actionText() {
      return this.isNew ? "Create" : "Update";
    },
    validForm() {
      return (
        this.schema.title !== "" &&
        this.schema.reportId !== "" &&
        this.schema.workspaceId !== ""
      );
    },
  },
  mounted() {
    this.schema = this.schemaOrg;
  },
  methods: {
    isNumeric(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[0-9]+$/.test(char)) return true;
      else e.preventDefault();
    },
    confirmDelete() {
      this.popupOpen = false;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: `Delete this report permanently? There is no way to undo this`,
        accept: this.deleteSchema,
      });
    },
    async deleteSchema() {
      await this.$store.dispatch(
        "cockpitReports/deleteCockpitReport",
        this.schema.id
      );
    },
    show(schema) {
      if (schema) {
        this.schema = schema;
      } else {
        this.schema = this.schemaOrg;
      }
      this.popupOpen = true;
    },
    async acceptClicked() {
      this.$vs.loading();
      this.schema.index = parseInt(this.schema.index);
      if (this.isNew) {
        await this.$store.dispatch(
          "cockpitReports/addCockpitReport",
          this.schema
        );
      } else {
        await this.$store.dispatch(
          "cockpitReports/updateCockpitReport",
          this.schema
        );
      }

      this.$vs.loading.close();
    },
  },
};
</script>

<style lang="scss" >
.buttons-footer-left {
  position: absolute;
  bottom: 14px;
  z-index: 100;
  animation: fadeIn ease 500ms forwards;
  animation-delay: 500ms;
  opacity: 0;
}
.con-vs-dialog .vs-dialog {
  max-width: 1000px !important;
  position: relative;
}
.vs-select--label {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6) !important;
}
</style>
